<mat-card class="need-help-deciding-card" appearance="outlined">
    <mat-card-header class="need-help-deciding-header">
        <div>
            <mat-card-title class="need-help-deciding-title">{{'NEEDHELPDECIDING.TITLE' | translate}}</mat-card-title>
            <mat-card-subtitle class="need-help-deciding-sub-title">
                {{'NEEDHELPDECIDING.DESCRIPTION' | translate}}
            </mat-card-subtitle>
        </div>
        <div class="chat-button-mobile" (click)="openChatBot()">
            <div class="mila-icon-mobile" style="background: white; border-radius: 50%; padding: 1px; display: flex; align-items: center; justify-content: center; width: 40px; height: 40px;">
            <app-mila-icon-svg style="transform: scale(0.68) !important;"></app-mila-icon-svg>
            </div>
            <div class="chat-button-text-mobile" style="white-space: wrap; min-width: 50px; max-width: 62px; display: flex; justify-content: center; align-items: center; text-align: center;">
                {{'CHAT' | translate}}
            </div>
        </div>
    </mat-card-header>
</mat-card>
